const error = {
  DOCUMENT_PARSING_ERROR: 'DOCUMENT_PARSING_ERROR',
  DOCUMENT_CANNOT_BE_MODIFIED: 'DOCUMENT_CANNOT_BE_MODIFIED',
  CREDENTIAL_NOT_ACTIVATED: 'CREDENTIAL_NOT_ACTIVATED',
  EMPTY_CERTIFICATE_CHAIN: 'EMPTY_CERTIFICATE_CHAIN',
  KEY_BLOCKED: 'KEY_BLOCKED',
  INCORRECT_KEYPASSWORD_OR_PUK: 'INCORRECT_KEYPASSWORD_OR_PUK',
  USER_SUSPENDED: 'USER_SUSPENDED',
  SIGNING_CERTIFICATE_IS_NOT_APPROPRIATE: 'SIGNING_CERTIFICATE_IS_NOT_APPROPRIATE',
  EVRO_CERTIFICATE_NOT_FOUND: 'EVRO_CERTIFICATE_NOT_FOUND',
  EVRO_USER_NOT_FOUND: 'EVRO_USER_NOT_FOUND',
  EVRO_CERTIFICATE_EXPIRED: 'EVRO_CERTIFICATE_EXPIRED',
  EVRO_OCCASIONAL_INVALID_SIGNATURE: 'EVRO_OCCASIONAL_INVALID_SIGNATURE',
  SIGNATURE_CHAIN_CONCURRENT_MODIFICATION: 'SIGNATURE_CHAIN_CONCURRENT_MODIFICATION',
  SIGNING_TRAIL_NOT_SUPPORTED_FOR_PASSWORD_PROTECTED_PDF: 'SIGNING_TRAIL_NOT_SUPPORTED_FOR_PASSWORD_PROTECTED_PDF'
}

export default error
